import React from "react";
import Icon from "../Common/Icon/Icon";
import Link from "../Common/Link/Link";

const SocialLinks = ({ links }) => {
  return (
    <div className="copy-right-social-link">
      <ul className="social-link">
        {links.map((link, index) => (
          <li key={index}>
            <Link href={link.href}>
              <Icon iconclassName={link.iconClass} />
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SocialLinks;
